"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class ReferencePathRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'psv-1-jaar-vast-cdt70015',
        description: 'The reference of the resource you have created',
    }),
    tslib_1.__metadata("design:type", String)
], ReferencePathRequest.prototype, "reference", void 0);
exports.default = ReferencePathRequest;
